import React from "react";
import { ClickAwayListener, Paper } from "@mui/material";
import { caseConstants } from "@_constants/case.constants";
import { filterConfig } from "./filterConfig";
import styles from "./CasesFilterMenu.module.css";

const iconStyle = { marginBottom: "-5px", marginRight: "8px" };

const filterOrder = [
  caseConstants.CASE_FILTER_REQUIRE_ATTENTION,
  caseConstants.CASE_FILTER_MAIL,
  caseConstants.CASE_FILTER_REMINDER,
  caseConstants.CASE_FILTER_UPLOADED_LICENSE,
  caseConstants.CASE_FILTER_FAILED_EMAIL,
  caseConstants.CASE_FILTER_FAILED_LETTERS,
  caseConstants.CASE_FILTER_FAILED_PAYMENT,
  caseConstants.CASE_FILTER_PAUSED,
  caseConstants.CASE_FILTER_IDLE_CASES,
];

function CasesFilterMenu({ onActivateFilter, onClose }) {
  return (
    <ClickAwayListener onClickAway={onClose}>
      <Paper className={styles.filterMenuPaper} data-testid="cases-filter-menu">
        {filterOrder.map((filter) => {
          const { icon: Icon, label } = filterConfig[filter];
          return (
            <div
              key={filter}
              className={styles.filterMenuRow}
              onClick={() => onActivateFilter(filter)}
              data-testid={`cases-filter-menu-item-${filter}`}
            >
              <Icon style={iconStyle} />
              {label}
            </div>
          );
        })}
      </Paper>
    </ClickAwayListener>
  );
}

export default CasesFilterMenu;
